
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5616_8237)"}},[_c('path',{attrs:{"fill":"#F3F3F3","d":"M1-.67h48v48H1z"}}),_c('path',{attrs:{"fill":"#F35325","d":"M3.087 1.417h20.87v20.87H3.086z"}}),_c('path',{attrs:{"fill":"#81BC06","d":"M26.044 1.417h20.869v20.87h-20.87z"}}),_c('path',{attrs:{"fill":"#05A6F0","d":"M3.087 24.373h20.87v20.87H3.086z"}}),_c('path',{attrs:{"fill":"#FFBA08","d":"M26.044 24.373h20.869v20.87h-20.87z"}})]),_c('defs',[_c('clipPath',{staticClass:"i-clip0_5616_8237"},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h48v48H0z"}})])])])
          )
        }
      }
    